import { render, staticRenderFns } from "./IconTransaction.vue?vue&type=template&id=03d72702&"
import script from "./IconTransaction.vue?vue&type=script&lang=ts&"
export * from "./IconTransaction.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports